import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Tooltip,
} from "reactstrap";
import { useNavigate, useParams} from "react-router-dom";
import {
  DELETE_LICENSE_PLAN,
  GET_CATEGORY_DETAILS,
  GET_SINGLE_LICENSE_PLAN,
  LICENSE_CATEGORY,
  GET_LICENSE_PLAN,
  DELETE_CATEGORY_DETAILS,
  GET_SINGLE_LICENSE,
  UPDATE_LICENSE,
  ADD_TEMPLATE_INSTRUCTIONS,
} from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import { AGENCY_TEMPLATE_FORM } from "../../../constants/RoutePaths";
import Createnewcategory from "./Createnewcategory";
import { Link } from "react-router-dom";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import PlanCreateModal from "./PlanCreateModal";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { CATEGORY_DETAILS, NEWFORM } from "../../../redux/actions/ActionTypes";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import BackButtonSvg from "../../common/BackButtonSvg";

import {  JSONParser } from "../../../functions/Helper";
import { authHeader } from "../../../functions/CoreFunctions";
import { Info } from "../../common/Info";
import moment from "moment";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const initialValues = {
  planName: "",
  planDescription: "",
  isKennelLicense: false,
  isParkLicense: false,
  planAmount: "",
  validTo: "",
  isRenewal: false,
  isLifeTimePlan: false,
  isDogLicense: false,
  planDuration: "",
};
const categoryinitialValues = {
  categoryName: "",
  categoryOrder: "",
  categoryId: 0,
};
function CreateTemplate(props) {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [UpdateToogle, setUpdateToogle] = useState(false);
  const [flag, setflag] = useState(false);
  const [categoryFlag, setcategoryFlag] = useState(true);
  const [Licensecategorydetails, setLicensecategorydetails] = useState([]);
  const [LicensePlan, setLicensePlan] = useState([]);
  const Category = Licensecategorydetails.map((i) => i.categoryId);
  const [modal, setModal] = useState(false);
  const [Details, setDetails] = useState([]);
  const [CategoryDetails, setCategoryDetails] = useState([]);
  const DeleteAgency = useSelector((state) => state.Agencydelete);

  const { templateId } = useParams();
  localStorage.setItem("PAY_PUP_LS_TEMPLATE_ID", templateId);
  const [categoryForm, setcategoryForm] = useState(categoryinitialValues);
  const [formData, setformData] = useState(initialValues);
  const toggle = () => {
    if (DeleteAgency) return;
    setcategoryForm(categoryinitialValues);
    setcategoryFlag(true);
    setModal(!modal);
  };
  const { enqueueSnackbar } = useSnackbar();
  const [activeTab, setActiveTab] = useState("1");
  const [Loading, setLoading] = useState(false);
  const [planmodal, setPlanmodal] = useState(false);
  const [recall, setrecall] = useState(0);
  const [contentValue, setContentValue] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [error, setError] = useState('');
  const [characterCount, setCharacterCount] = useState('');
  const plantoggle = () => {
    setformData(initialValues);
    setflag(true);
    setPlanmodal(!planmodal);
  };
  const categorytoggle = () => {
    if (DeleteAgency) return;

    setcategoryFlag(false);
    setModal(!modal);
  };
  const EditModule = () => {
    if (DeleteAgency) return;

    setflag(false);
    setPlanmodal(!planmodal);
  };
  const tabtoggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };

  const GetLicense = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_SINGLE_LICENSE,
      headers: authHeader(),

      params: {
        templateId: templateId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setContentValue(data.instruction)
        if (data.instruction && data.instruction.length) {
          const plainText = stripHtml(data.instruction).trim();
          setCharacterCount(plainText.length);
        } else {
          setCharacterCount(0);
        }
        let Details = JSONParser(data.categoryDetails, []);
        setLicensecategorydetails(Details);
        if (data.categoryDetails.length === 0) {
          setCategoryDetails(data.categoryDetails);
          dispatch({ type: NEWFORM });
        } else {
          const Value = [...JSONParser(data.categoryDetails, [])];
          function compare(a, b) {
            // Use toUpperCase() to ignore character casing
            const bandA = a.categoryOrder.toString();
            const bandB = b.categoryOrder.toString();

            let comparison = 0;
            if (bandA > bandB) {
              comparison = 1;
            } else if (bandA < bandB) {
              comparison = -1;
            }
            return comparison;
          }

          Value.sort(compare);
          setCategoryDetails(Value);
          dispatch({
            type: CATEGORY_DETAILS,
            payload: JSON.parse(data.categoryDetails).map((cat, index) => ({
              uniqueId: (Date.now() + index).toString(),
              categoryId: cat.categoryId,
              categoryName: cat.categoryName,
              categoryOrder: cat.categoryOrder,
              validationType: "string",
              validations: [
                {
                  type: "required",
                  params: ["Required"],
                },
              ],
            })),
          });
        }

        setDetails(data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    
    } finally {
      setLoading(false);
    }
  };

  const GetLicensePlan = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_PLAN,
      headers: authHeader(),

      params: {
        templateId: templateId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setLicensePlan(data);
        setLoading(false);
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  const DeleteSelectedplan = (e) => {
    const ID = e.currentTarget.dataset.licenseplanid;
    if (DeleteAgency) return;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete Plan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        DeletePlan(ID);
      }
    });
  };

  const DeletePlan = async (ID) => {
    setLoading(true);
    const config = {
      method: "DELETE",
      headers: authHeader(),

      url: DELETE_LICENSE_PLAN,
      params: {
        licensePlanId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        CustomAlertMessage(
          "Plan Deleted Sucessfully",
          "success",
          enqueueSnackbar
        );
        SuccessFullRecall();
        setLoading(false);
      }
    } catch (error) {
    
    } finally {
      setLoading(false);
    }
  };

  const Delete = (e) => {
    if (DeleteAgency) return;

    const ID = e.currentTarget.dataset.categoryid;
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete Category",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteCategory(ID);
      }
    });
  };

  const DeleteCategory = async (ID) => {
    setLoading(true);
    const CatVAlue = CategoryDetails.filter((cat) => cat.categoryId !== ID);

    const config = {
      method: "DELETE",
      url: DELETE_CATEGORY_DETAILS,
      headers: authHeader(),

      params: {
        categoryId: ID,
      },
    };

    const Catconfig = {
      method: "POST",
      url: LICENSE_CATEGORY,
      headers: authHeader(),

      data: {
        licenseCategoryDetails: CatVAlue.map((cat, index) => ({
          categoryName: cat.categoryName,
          categoryOrder: index + 1,
          categoryId: cat.categoryId,
          categoryPlaceHolder: cat.categoryPlaceHolder,
        })),
        templateId: templateId,
      },
    };
    // modify category object. remove the deleted category
    try {
      const response = await API(config);
      const Catresponse = await API(Catconfig);


      if (
        response.data.status === "Success" &&
        Catresponse.data.status === "Success"
      ) {
        CustomAlertMessage(
          "Category Deleted Sucessfully",
          "success",
          enqueueSnackbar
        );
        setLoading(false);
      }
    } catch (error) {
     
    } finally {
      SuccessFullRecall();
      setLoading(false);
    }
  };

  const EditSelectedplan = async (e) => {
    if (DeleteAgency) return;

    setflag(false);
    const ID = e.currentTarget.dataset.licenseplanid;
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_SINGLE_LICENSE_PLAN,
      headers: authHeader(),

      params: {
        licensePlanId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status, licensePlanData } = response.data;
      if (status === "Success") {
        setformData({
          ...licensePlanData,
          validTo: licensePlanData.validTo ? licensePlanData.validTo : "",
        });
        EditModule();
      }
    } catch (error) {
    
    } finally {
      setLoading(false);
    }
  };

  const EditCategory = async (e) => {
    if (DeleteAgency) return;

    const ID = e.currentTarget.dataset.categoryid;
    const config = {
      method: "GET",
      url: GET_CATEGORY_DETAILS,
      headers: authHeader(),

      params: {
        categoryId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setcategoryForm(data[0]);
        categorytoggle();
        setUpdateToogle(true);
      }
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      CategoryDetails,
      result.source.index,
      result.destination.index
    );
    setCategoryDetails(items);
    setrecall(recall + 1);
  };

  const UpdateCategory = async () => {
    if (DeleteAgency) return;

    if (CategoryDetails.length !== 0) {
      const config = {
        method: "POST",
        url: LICENSE_CATEGORY,
        headers: authHeader(),

        data: {
          licenseCategoryDetails: CategoryDetails.map((cat, index) => ({
            categoryName: cat.categoryName,
            categoryOrder: index + 1,
            categoryId: cat.categoryId,
            categoryPlaceHolder: cat.categoryPlaceHolder,
          })),
          templateId: templateId,
        },
      };
      try {
        const response = await API(config);
        const { status } = response.data;
        if (status === "Success") {
          GetLicense();
        }
      } catch (error) {
       
      } finally {
      }
    }
  };

  const Request = (e) => {
    if (DeleteAgency) return;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to Request",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        Rerequest();
      }
    });
  };

  const Rerequest = async (values) => {
    const config = {
      method: "PUT",
      url: UPDATE_LICENSE,
      data: {
        templateId: templateId,
        status: "Pending",
      },
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        SuccessFullRecall();
      }
    } catch (error) {
      const { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
    }
  };

  const SuccessFullRecall = () => {
    GetLicense();
    GetLicensePlan();
  };

  const back = () => {
    history(-1);
  };
  useEffect(() => {
    GetLicense();
    GetLicensePlan();
  }, []);

  useEffect(() => {
    UpdateCategory();
  }, [recall]);

  const Showreason = (a) => {
    Swal.fire(a);
  };

  const stripHtml = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || '';
};
  const handleContentChange = (val) => {
    const plainText = stripHtml(val).trim();
    setContentValue(val);
   
    if (plainText.length === 0) {
      setIsTouched(false);
    } else {
      setError('');
      setIsTouched(true);
    }
    setCharacterCount(plainText.length);
};
  const handleSaveInstructionsApi = async () => {
    const plainText = stripHtml(contentValue).trim();
    if (plainText.length === 0) {
      setError('Instructions is required.');
    } else if (plainText.length > 5000) {
      setError('Instructions must be 5000 characters or less');
    } else {
      setError('');
     
      setLoading(true);
      const config = {
        method: "PUT",
        url: ADD_TEMPLATE_INSTRUCTIONS,
        headers: authHeader(),
        data: {
          templateId: templateId,
          instruction: contentValue
        },
      };
      try {
        const response = await API(config);
        const { status } = response.data;
        if (status === "Success") {
          setIsTouched(false);
          CustomAlertMessage('Successfully saved', "success", enqueueSnackbar);
        }
      } catch (error) {
        console.error(error);
        setIsTouched(false);
      } finally {
        setLoading(false);
      }
    }
};
  return (
    <div>
      {Loading ? <CustomPageLoading /> : ""}
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>{Details.licenseName}</h4>

            <h3>
              {Details.templateStatus === "Rejected" && (
                <p>
                  {" "}
                  Rejected by Agency{" "}
                  <span
                    onClick={() => Showreason(Details.templateComments)}
                    style={{ textDecoration: "underline", color: "blue" }}
                  >
                    {" "}
                    Show More{" "}
                  </span>
                </p>
              )}
            </h3>

            <span className="badge badge-primary createLicenseStatus">
              {Details.templateStatus === "Pending?" &&
                "This template is Pending"}
            </span>

            <span className="badge badge-primary createLicenseStatus">
              {Details.isActive
                ? "This template is Active so you cannot edit this template"
                : ""}
            </span>

            <div className="top-btn">
              <Button color="primary" onClick={back}>
                <BackButtonSvg /> Back
              </Button>
            </div>
          </div>
          <div>
            <Nav tabs fixed="top" className="mt-3">
              <NavItem>
                <NavLink
                  className={{ active: activeTab === "1" }}
                  onClick={() => {
                    tabtoggle("1");
                  }}
                >
                  Category
                  <Tooltip
                    isOpen={id === "category" && tooltipOpen}
                    target={"category"}
                    toggle={() => tooltiptoggle("category")}
                  >
                    View pet license category details
                  </Tooltip>
                  <span id={"category"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={{ active: activeTab === "2" }}
                  onClick={() => {
                    tabtoggle("2");
                  }}
                >
                  Plans
                  <Tooltip
                    isOpen={id === "plans" && tooltipOpen}
                    target={"plans"}
                    toggle={() => tooltiptoggle("plans")}
                  >
                    View pet license plan details
                  </Tooltip>
                  <span id={"plans"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={{ active: activeTab === "3" }}
                  onClick={() => {
                    tabtoggle("3");
                  }}
                >
                  Instructions
                  <Tooltip
                    isOpen={id === "instructions" && tooltipOpen}
                    target={"instructions"}
                    toggle={() => tooltiptoggle("instructions")}
                  >
                    View pet license instructions
                  </Tooltip>
                  <span id={"instructions"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <div className="cn-category">
                {activeTab === "1" ? (
                  <Button
                    disabled={DeleteAgency || Details.isActive}
                    onClick={toggle}
                    color="primary"
                  >
                    <svg
                      className="mr-3"
                      xmlns="http://www.w3.org/2000/svg"
                      width="12.401"
                      height="12.402"
                      viewBox="0 0 12.401 12.402"
                    >
                      <g
                        id="Icon_feather-plus"
                        data-name="Icon feather-plus"
                        transform="translate(-6.6 -6.6)"
                      >
                        <path
                          id="Path_82"
                          data-name="Path 82"
                          d="M18,7.5V18.1"
                          transform="translate(-5.199)"
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.8"
                        />
                        <path
                          id="Path_83"
                          data-name="Path 83"
                          d="M7.5,18H18.1"
                          transform="translate(0 -5.199)"
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.8"
                        />
                      </g>
                    </svg>
                    Create New Category
                  </Button>
                ) : activeTab == 2 ? (
                  <Button
                    disabled={DeleteAgency || Details.isActive}
                    color="primary"
                    onClick={plantoggle}
                  >
                    Create New Plan
                  </Button>
                ) : ('')}
              </div>
              {Details.templateStatus === "Rejected" ? (
                <Button color="primary" onClick={Request}>
                  Request
                </Button>
              ) : (
                ""
              )}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Card body className="mt-4 create-min-card">
                  <Row>
                    <Col sm="12" md={{ size: 6, offset: 3 }}>
                      <div className="category-list">
                        {CategoryDetails.length === 0 ? (
                          <p style={{ textAlign: "center" }}>
                            No categories found.
                          </p>
                        ) : (
                          <>
                            <div>
                              <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="droppable">
                                  {(provided) => (
                                    <div
                                      {...provided.droppableProps}
                                      ref={provided.innerRef}
                                    >
                                      {CategoryDetails.map((cat, index) => (
                                        <Draggable
                                          key={
                                            Details.isActive
                                              ? ""
                                              : cat.categoryId.toString()
                                          }
                                          draggableId={
                                            Details.isActive
                                              ? ""
                                              : cat.categoryId.toString()
                                          }
                                          index={index}
                                        >
                                          {(provided) => (
                                            <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              id={cat.categoryId}
                                              className="licenseEditTool active"
                                            >
                                              <div className=" categoryList row">
                                                <div className="left item-center d-flex">
                                                  <span>
                                                    {cat.categoryOrder}
                                                  </span>
                                                </div>
                                                <div className="center item-center d-flex">
                                                  <h4>{cat.categoryName}</h4>
                                                </div>

                                                <div className="right item-center justify-end d-flex">
                                                  <Link
                                                    to={{
                                                      pathname: `${AGENCY_TEMPLATE_FORM}/${cat.categoryId}`,
                                                      state: {
                                                        categoryName:
                                                          cat.categoryName,
                                                        categoryOrder:
                                                          cat.categoryOrder,
                                                      },
                                                    }}
                                                  >
                                                    <Button
                                                      disabled={
                                                        DeleteAgency ||
                                                        Details.isActive
                                                      }
                                                      className="editBtn"
                                                      color="link"
                                                    >
                                                      {" "}
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="#1b3e6f6b"
                                                        stroke="#fff"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                      >
                                                        <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z" />
                                                        <path d="M14 3v5h5M16 13H8M16 17H8M10 9H8" />
                                                      </svg>
                                                    </Button>
                                                  </Link>
                                                  <Button
                                                    disabled={
                                                      DeleteAgency ||
                                                      Details.isActive
                                                    }
                                                    className="editBtn"
                                                    data-categoryid={
                                                      cat.categoryId
                                                    }
                                                    onClick={EditCategory}
                                                    color="link"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10.928"
                                                      height="10.928"
                                                      viewBox="0 0 10.928 10.928"
                                                    >
                                                      <path
                                                        id="Icon_material-mode-edit"
                                                        data-name="Icon material-mode-edit"
                                                        d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                                        transform="translate(-4.5 -4.496)"
                                                        fill="#1b3e6f6b"
                                                      />
                                                    </svg>
                                                  </Button>

                                                  <Button
                                                    disabled={
                                                      DeleteAgency ||
                                                      Details.isActive
                                                    }
                                                    onClick={Delete}
                                                    data-categoryid={
                                                      cat.categoryId
                                                    }
                                                    className="deleteBtn"
                                                    color="link"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10.236"
                                                      height="13.161"
                                                      viewBox="0 0 10.236 13.161"
                                                    >
                                                      <path
                                                        id="Icon_material-delete"
                                                        data-name="Icon material-delete"
                                                        d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                                        transform="translate(-7.5 -4.5)"
                                                        fill="#1b3e6f6b"
                                                      />
                                                    </svg>
                                                  </Button>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </Draggable>
                                      ))}
                                    </div>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </div>
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Card>
              </TabPane>

              <TabPane tabId="2">
                <Card body className="mt-4 create-min-card">
                  <Row className="mt-4 create-plan plan-list">
                    {LicensePlan.length === 0 ? (
                      <p style={{ textAlign: "center" }}>No plan found.</p>
                    ) : (
                      <>
                        {LicensePlan.map((i) => (
                          <Col md="4">
                            <div className="box">
                              <h4>{i.planName}</h4>
                              <h1>
                                <strong>$</strong>
                                {parseFloat(i.planAmount).toFixed(2)}
                              </h1>
                              <span>
                                {i.isLifeTimePlan && "Life Time Plan"}

                                {!!i.validTo && (
                                  <>
                                    {" "}
                                    <span>Till Date</span>{" "}
                                    {moment(i.validTo).format("MM-DD-YYYY")}
                                  </>
                                )}
                                {!!i.planDuration && i.planDuration + "/ year"}
                              </span>
                              <ul>
                                <li>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17.011"
                                    height="17.011"
                                    viewBox="0 0 17.011 17.011"
                                  >
                                    <path
                                      id="Icon_material-check-box"
                                      data-name="Icon material-check-box"
                                      d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                                      transform="translate(-4.5 -4.5)"
                                      fill="#fff"
                                    />
                                  </svg>

                                  {i.isRenewal ? (
                                    <>
                                      {" "}
                                      Renewal for{" "}
                                      {i.isKennelLicense
                                        ? "kennel license"
                                        : i.isParkLicense
                                        ? "Park License"
                                        : i.isDogLicense
                                        ? "Dog License"
                                        : ""}{" "}
                                    </>
                                  ) : (
                                    <>
                                      {i.isKennelLicense
                                        ? "kennel license"
                                        : i.isParkLicense
                                        ? "Park License"
                                        : i.isDogLicense
                                        ? "Dog License"
                                        : ""}
                                    </>
                                  )}
                                </li>
                              </ul>
                              <p>{i.planDescription}</p>

                              {JSONParser(i.CategoryDetails, []).map((i) => (
                                <ul>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17.011"
                                      height="17.011"
                                      viewBox="0 0 17.011 17.011"
                                    >
                                      <path
                                        id="Icon_material-check-box"
                                        data-name="Icon material-check-box"
                                        d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                                        transform="translate(-4.5 -4.5)"
                                        fill="#fff"
                                      />
                                    </svg>
                                    {i.categoryName}
                                  </li>
                                </ul>
                              ))}

                              <div className="btn-section">
                                <Button
                                  className="primary-white"
                                  data-licenseplanid={i.licensePlanId}
                                  disabled={DeleteAgency || Details.isActive}
                                  onClick={EditSelectedplan}
                                >
                                  Edit
                                </Button>
                                <Button
                                  color="danger"
                                  disabled={DeleteAgency || Details.isActive}
                                  data-licenseplanid={i.licensePlanId}
                                  onClick={DeleteSelectedplan}
                                >
                                  Delete
                                </Button>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </>
                    )}
                  </Row>
                </Card>
              </TabPane>
            </TabContent>
            {activeTab == 3 && (
                                     <div style={{ marginBottom: '20px' }}>
              <ReactQuill
                theme="snow"
                value={contentValue}
                onChange={handleContentChange}
                placeholder="Write your instructions here..."
                style={{ height: '400px', width: '100%', marginBottom: '20px' }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false] }],
                    ['bold', 'italic', 'underline'],
                    ['code-block'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    // ['clean']
                  ]
                }}
                formats={[
                  'header', 'bold', 'italic', 'underline',
                  'code-block', 'list', 'bullet'
                ]}
                />

                <div style={{ display: 'flex', justifyContent: 'left', marginTop: '53px', alignItems: 'flex-start' }}>
                    <div style={{color: 'red',fontFamily: 'sans-serif',fontSize: '12px',}}>
                          {error ? error : ' '}
                      </div>
                </div>
                <div 
    style={{display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'}}
>
                <div style={{ textAlign: 'left', color: '#555' }}>
                        Total Characters Count: {characterCount}
                 </div>
                
                <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                        <button
                        style={{
                          padding: '10px 20px',
                          fontSize: '16px',
                          backgroundColor: isTouched ? 'rgb(76, 175, 80)' : '#ccc',
                          color: isTouched ? 'white' : '#666',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: isTouched ? 'pointer' : 'not-allowed',
                          transition: 'opacity 0.3s',
                        }}
                        onClick={handleSaveInstructionsApi}
                        disabled={!isTouched}
                      >
                        Save
                      </button>
                  </div>
                  </div>
                
            </div>
            
                        )}
          </div>
        </Container>
      </div>

      <div>
        <PlanCreateModal
          flag={flag}
          formData={formData}
          Licensecategorydetails={Licensecategorydetails}
          SuccessFullRecall={SuccessFullRecall}
          templateId={templateId}
          Category={Category}
          planmodal={planmodal}
          plantoggle={plantoggle}
        />
        <Createnewcategory
          categoryFlag={categoryFlag}
          CategoryDetails={CategoryDetails}
          categoryForm={categoryForm}
          GetLicense={GetLicense}
          GetLicensePlan={GetLicensePlan}
          UpdateToogle={UpdateToogle}
          recall={recall}
          setrecall={setrecall}
          templateId={templateId}
          Licensecategorydetails={Licensecategorydetails}
          modal={modal}
          toggle={toggle}
        />
      </div>
    </div>
  );
}

export default CreateTemplate;
